export const language: any = {
  main: "主页",
  ingredients: "食材",
  ai_chef: "AI大厨",
  favorites: "收藏",
  menu: "菜单",
  get_start: "开始",
  title_first_1: "AI根据年龄推荐食谱",
  title_second_1: "从菜单到食谱完美安排",
  content_1: "无需再为每日菜单和卡路里担忧，现在就让Hey Cooker帮您吧！",
  title_first_2: "今天有点冷，辛苦了。",
  title_second_2: "下班后，吃一碗部队火锅怎么样？",
  content_2: "找找冰箱里剩下的午餐肉和方便面，一起做个简单的晚餐吧！",
  my_food_ingredients: "不知道该做什么菜？",
  btn_add_photo: "选择图片或拍照",
  my_food_reason: "请选择你已有的食材",
  btn_get_cooking: "获取AI菜品推荐",
  enriching_title: "丰富你的身体和心灵",
  enriching: "食谱集",
  photo_registration_title: "拍摄照片或收据，<br/>获取菜单推荐",
  photo_registration_content: `通过AI识别食材并分析食谱，<br/>增加烹饪的乐趣！`,  
  food_suggestions_title: "不知道吃什么而烦恼吗？",
  food_suggestions_sub_title: "主题菜品",
  our_interests_title: "为您和家人定制合适的菜单！",
  our_interests_sub_title: "请根据年龄和性别选择。",
  favorite_title: "多样化的烹饪笔记",
  weather_title: "适合寒冷天气的菜品",
  video_title: "通过生动的视频查看",
  tag: {
    close: "收起",
    open: "展开"
  },
  no_data: "没有数据",
  update_version_submit: "立即更新",
  update_version_title: "有新版本可用",
  update_version_content: "为了获得最佳使用体验，请更新到最新版本的应用程序。",
  close_btn: "关闭",
  not_video_id: "视频不存在",
  favorite_login: "登录或注册以保存您喜欢的食谱列表。",
  favorite_section_title: "别忘了查看您保存的食谱",
  favorite_section_description: "我最喜欢的食谱",
  discover: "发现",
  my_cooker: "我的厨房",
  view_recipe: "查看选定食材的菜谱",
  my_ingredient: "我的食材",
  add_ingredient: "添加我的食材",
  video_section_title: "通过视频发现并感受",
  video_section_description: "推荐菜肴视频",
  age_10: "10岁以下",
  age_10_to_20: "10-20岁",
  age_20_to_30: "20-30岁",
  age_30_to_40: "30-40岁",
  age_40_to_50: "40-50岁",
  age_more_50: "50岁以上",
  suggest_section_title: "嘿！Cooker 将帮助您选择",
  suggest_section_description: "您感兴趣的话题是什么？",
  weather_title1: "今日推荐",
  weather_title2: "雨冷天吃什么好呢？",
  tasteSuggestion1: "满足你的味蕾",
  tasteSuggestion2: "专属你的味道",
  tasteTitle1: "辛辣 <br />诱人",
  tasteDescription1: "#炒 #烤 #雨天",
  tasteTitle2: "清新 <br />淡雅",
  tasteTitle3: "酸味 <br />刺激",
  tasteTitle4: "香甜 <br />可口",
  tasteTitle5: "混合 <br />诱惑",
  tasteDescription2: "#新鲜 #纤维 #节食",
  tasteDescription3: "#酸 #甜 #刺激",
  tasteDescription4: "#特别 #种子 #魔法",
  tasteDescription5: "#味道 #营养 #感觉",
  suggest_item_title1: "简单的菜肴",
  suggest_item_description1: `简单的早餐和午餐<br/>食谱`,
  suggest_item_title2: "减肥",
  suggest_item_description2: `低碳水化合物<br/>非常美味`,
  suggest_item_title3: "年末美食",
  suggest_item_description3: `家庭聚会美食`,
  suggest_item_title4: "健康食品",
  suggest_item_description4: `为了健康的身体和心灵<br/>让选择更健康`,
  suggest_item_title5: "简单零食",
  suggest_item_description5: `下酒小菜`,
  history: "图像分析历史",
  community: {
    sub_title: "与大家一起烹饪",
    title: "嘿！Cooker 社区搜索",
    trending: "趋势",
    follow: "已关注",
    video: "视频",
    discover: "发现",
    no_data: "Hey！Cooker社区中没有新的更新",
    discover_post: "在社区中搜索更多帖子"
  },
  user_suggest_title1: "今日推荐",
  user_suggest_title2: "随机食谱推荐",
}


